let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("43LVx")).then(() => parcelRequire('7b5A1'));